import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import CycodeCredentialsForm from "./CycodeCredentialsForm";
import CycodeMappingFormV2 from "./CycodeMappingFormV2";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import CycodeMappingForm from "./CycodeMappingForm";
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils';
import ContentOverlay from 'components/ContentOverlay';
import _, { capitalize } from "lodash";
import CycodeCSPMMappingForm from "./CycodeCSPMMappingForm";

export default function CycodeConfigListing(props) {
  const featureFlags = useFeatureFlag();
  const columns = useMemo(() => [
    {
      title: "Project",
      dataIndex: "projectName",
      width: 200,
      render: projectName => {
        if(featureFlags.CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS){
          if(!projectName) return CellRenderers.VALUE_OR_NA();
          const modifiedProjectName = projectName
          .split(',')
          .map(item => item.trim() === '' ? 'N/A' : item)
          .join(',');
          
          return columnRenderArrayData(modifiedProjectName);
        }
        if(!projectName) return "All";
        return projectName;
      }
    },
    {
      title: "Repository",
      dataIndex: "repositoryNames",
      width: 250,
      render: (repository, record) => {
        if(!repository){
          return CellRenderers.VALUE_OR_NA();
        }
        if (featureFlags.DISCOVERY_CYCODE_REPO_NAME_WITH_PROJECT) {
          const { projectName = '' } = record;
          const repositoryArray = _.split(repository, ',');
          const projectArray = _.split(projectName, ';');
          const content = _.map(repositoryArray, (repoName, index) => <p>{projectArray[index] ? `${repoName} - [${projectArray[index]}]` : repoName}</p>);
          return <ContentOverlay content={content} />
        } else {
          return columnRenderArrayData(repository);
        }
      },
    },
    ...(featureFlags.CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS ? [{
      title: "CSPM",
      dataIndex: "accountId",
      render: (accountId) => CellRenderers.VALUE_OR_NA(capitalize(accountId)),
      width: 100,
    }]
    :
    [])
  ], [featureFlags]);

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={featureFlags.CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS ?  CycodeCSPMMappingForm : featureFlags.DISCOVERY_CYCODE_REPO_NAME_WITH_PROJECT ? CycodeMappingFormV2 : CycodeMappingForm}
      CredentialsForm={CycodeCredentialsForm}
      extraColumns={columns}
    />
  );
}
